var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReload = function SvgReload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1C4566",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6 1a8.6 8.6 0 0 1 8.6 8.6A8.6 8.6 0 1 1 9.6 1Zm0 1.119a7.48 7.48 0 1 0 0 14.962 7.48 7.48 0 0 0 0-14.962Z",
    stroke: "#1C4566",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.201 3.684a.743.743 0 0 1 .61.328.662.662 0 0 1 .09.528.68.68 0 0 1-.236.366l-.094.064-.348.204.145.018c2.43.353 4.25 2.333 4.253 4.677l-.005.214c-.118 2.58-2.397 4.594-5.127 4.537-2.73-.058-4.914-2.166-4.91-4.747 0-.305.259-.55.576-.55.317 0 .576.244.576.549-.001 1.975 1.67 3.592 3.77 3.642 2.098.05 3.854-1.487 3.958-3.46.095-1.78-1.187-3.334-2.979-3.727l-.139-.027.207.127c.24.15.363.418.322.683l-.024.1a.728.728 0 0 1-.699.493.763.763 0 0 1-.305-.064l-.093-.048-2.17-1.347a.682.682 0 0 1-.33-.591.678.678 0 0 1 .263-.523L7.6 5.07l2.213-1.28a.797.797 0 0 1 .39-.107Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reload.0d7f0f5c.svg";
export { ForwardRef as ReactComponent };